export default __webpack_public_path__ + "static/news3-d26e11796c463e4b72c2b21c9c4c756c.webp";